import { UsageAnmeldequoteCharts } from './UsageAnmeldequoteCharts';
import { UsageEntwicklungCharts } from './UsageEntwicklungCharts';
import { UsageExportButton } from './UsageExport';
import { UsageKpiCharts } from './UsageKpiCharts';
import { UsageTitleSlide } from './UsageReportShared';
import { UsageViewsCharts } from './UsageViewsCharts';

// Übersicht für den Quartalsbericht: eine "Folie" pro Karte, in der Reihenfolge des PPT-Berichts.
// Detailtabellen zu den einzelnen Kennzahlen liegen in den Unterpunkten des Menüs.
export const UsageOverview = () => {
	return (
		<div className="usage-report">
			<UsageExportButton />
			<UsageTitleSlide />
			<UsageAnmeldequoteCharts />
			<UsageViewsCharts />
			<UsageEntwicklungCharts />
			<UsageKpiCharts />
		</div>
	);
};
